import React, { createContext, useState, useContext, useEffect } from 'react';
import useDataApi from '../hooks/useDataApi';

const NomenclatorContext = createContext();
const SetNomenclatorContext = createContext();

export function NomenclatorProvider({ children }) {
  const [nomenclator, setNomenclator] = useState(null);
  const [fetchState, setDataUrl] = useDataApi({ cache: true });
  useEffect(() => {
    //si se ha podido hacer fetch en el script inline lo usamos
    if (window.nomenclator) {
      window.nomenclator.then(x => setNomenclator(x));
    } else {
      //si no hacer fetch ahora
      setDataUrl('/json/nomenclator.json');
    }
  }, [setDataUrl]);
  useEffect(() => {
    if (!fetchState.isLoading && fetchState.data) {
      setNomenclator(fetchState.data);
    }
  }, [fetchState.data, fetchState.isLoading]);

  if (process.env.NODE_ENV === 'development') {
    nomenclator && console.log({ nomenclator });
  }

  return nomenclator ? (
    <NomenclatorContext.Provider value={nomenclator}>
      {children}
    </NomenclatorContext.Provider>
  ) : null;
}

export function useNomenclator() {
  const nomenclator = useContext(NomenclatorContext);
  if (!nomenclator)
    throw new Error('useNomenclator debe ser usado bajo NomenclatorProvider');
  return nomenclator;
}

export function useSetNomenclator() {
  return useContext(SetNomenclatorContext);
}
